import React, { useMemo, useState } from 'react';
import {useParams} from 'react-router-dom';
import {
    ListCheckIcons, SettingsIcons
} from "../../../../icons/icons";
import { MainLayout } from "../../../../ui";
import { Config } from './Config'
import { Results } from './Results'


export const Psychometric = () => {
    const [currentSubTab, setCurrentSubTab] = useState<'Config' | 'Results'>('Config');
    const [psychometricType, setPsychometricType] = useState<'Staff' | 'Managers'>('Staff');
    const { id } = useParams<{ id: string }>();

    const sidebarButtons = useMemo(
        () => [
            { label: 'Config', Icon: SettingsIcons, disabled: false },
            { label: 'Results', Icon: ListCheckIcons, disabled: false },
        ],
        [],
    );

    const handleSidebarChange = (tab: 'Config' | 'Results') => {
        setCurrentSubTab(tab);
    };

    return (
        <div className='flex mt-5 gap-6'>
            <div className='flex flex-col gap-3 w-20 py-4 px-2 bg-slate-50/50 border border-slate-100 rounded-3xl shrink-0 h-fit sticky top-5'>
                {sidebarButtons.map((button, index) => {
                    if (button.disabled) return null;
                    const isActive = currentSubTab === button.label;
                    const Icon = button.Icon;
                    return (
                        <button
                            key={index}
                            onClick={() => handleSidebarChange(button.label as 'Config' | 'Results')}
                            className='group flex flex-col items-center transition-all duration-200'
                        >
                            <div
                                className={`w-10 h-10 rounded-2xl flex items-center justify-center transition-all duration-300 border ${
                                    isActive
                                        ? 'bg-emerald-600 border-emerald-600 text-white shadow-lg shadow-emerald-100 scale-110'
                                        : 'bg-white border-slate-200 text-slate-400 hover:border-emerald-400 hover:text-emerald-600 group-hover:shadow-md'
                                }`}
                            >
                                <Icon
                                    className={`w-5 h-5 ${
                                        isActive ? 'text-white' : 'text-slate-400'
                                    }`}
                                />
                            </div>
                            <p
                                className={`text-[8px] mt-1 font-bold uppercase tracking-tight text-center leading-tight transition-colors ${
                                    isActive
                                        ? 'text-emerald-600'
                                        : 'text-slate-400 group-hover:text-emerald-500'
                                }`}
                            >
                                {button.label}
                            </p>
                        </button>
                    );
                })}
            </div>
            <MainLayout>
                {currentSubTab === 'Config' ? <Config /> : <Results jobOpeningId={id}/>}
            </MainLayout>
        </div>
    );
};